export default __webpack_public_path__ + "static/media/success_payment.a17f36ed.svg";